import script from "./workflow-review-loader.vue?vue&type=script&setup=true&lang=ts"
export * from "./workflow-review-loader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__